import React, {useEffect, useState, useRef} from 'react';
import './App.css';
import {RouterProvider} from "react-router-dom";
import {useIsAuthenticated, useMsal, useMsalAuthentication} from "@azure/msal-react";
import {loginRequest} from "./msal/authConfig";
import {InteractionType} from "@azure/msal-browser";
import {isJwtExpiringSoon} from "./msal/authHelper";
import {tokenService} from "./msal/tokenService";
import {initializeAuthenticatedFetch} from "./msal/authenticatedFetchService";
import FirstPersonView from "./General/EasterEgg/FirstPersonView";

function App(props: { router: any }) {
    useMsalAuthentication(InteractionType.Redirect, { ...loginRequest });
    const { instance, inProgress, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [showGame, setShowGame] = useState(true);
    const bgAudioRef = useRef<HTMLAudioElement | null>(null);
    const [bgmStarted, setBgmStarted] = useState(false);
    const [muted, setMuted] = useState(false);
    const [audioPlaying, setAudioPlaying] = useState(false);
    const DEFAULT_VOLUME = 0.5; // reduced volume

    useEffect(() => {
        if (bgAudioRef.current) {
            bgAudioRef.current.volume = DEFAULT_VOLUME;
        }
    }, []);

    useEffect(() => { console.log('showGame changed:', showGame); }, [showGame]);
    
    useEffect(() => {
        async function getToken() {
            if (instance && inProgress == 'none' && accounts[0]) {
                if (accounts[0].idToken) {
                    tokenService.storeToken(accounts[0].idToken);
                }

                initializeAuthenticatedFetch(instance, accounts[0]);

                const token = await tokenService.getValidToken(instance, accounts[0]);
                // setTokenInState(token);
            }
        }
        getToken();
    }, [instance, inProgress, accounts])

    const handleStartAudio = () => {
        if (!bgmStarted) {
            try {
                if (bgAudioRef.current) bgAudioRef.current.volume = DEFAULT_VOLUME;
                bgAudioRef.current?.play();
                setBgmStarted(true);
                setAudioPlaying(true);
            } catch (_) {}
        }
    };
    const handleStopAudio = () => { try { bgAudioRef.current?.pause(); setAudioPlaying(false); } catch (_) {} };
    const handleToggleMute = () => {
        setMuted(prev => {
            const next = !prev;
            if (bgAudioRef.current) bgAudioRef.current.muted = next;
            return next;
        });
    };

    const playAudio = () => {
        try { bgAudioRef.current?.play(); setAudioPlaying(true); } catch (_) {}
    };
    const pauseAudio = () => {
        try { bgAudioRef.current?.pause(); setAudioPlaying(false); } catch (_) {}
    };
    const toggleAudio = () => {
        if (audioPlaying) {
            pauseAudio();
        } else {
            playAudio();
        }
    };

    const token = tokenService.getCachedToken();
    if (!isAuthenticated || !token || isJwtExpiringSoon(token, 5)) {
        return <></>;
    }

    return (
        <div className="App" style={{height: "100%"}}>
            <audio ref={bgAudioRef} src="/items.mp3" preload="auto" loop muted={muted} style={{ display: 'none' }} />
            {showGame ? (
                <FirstPersonView
                    onContinue={() => setShowGame(false)}
                    onStartAudio={handleStartAudio}
                    onStopAudio={handleStopAudio}
                    onToggleMute={handleToggleMute}
                    muted={muted}
                />
            ) : (
                <>
                    <a
                      href="https://uk26.accesscharityoftheyear.org/appeal/dementia-uk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="post-game-info"
                      aria-label="Information box"
                    >
                        <img src="/dementia.webp" alt="Info graphic" className="post-game-info-image" />
                        <div className="post-game-info-content">
                            <strong className="post-game-info-title">Merry Christmas!</strong>
                            <div className="post-game-info-text">Please consider supporting DementiaUK - the Access charity of the year.</div>
                        </div>
                    </a>
                    <button
                      id="playButton"
                      onClick={toggleAudio}
                      aria-label={audioPlaying ? 'Pause background music' : 'Play background music'}
                    >{audioPlaying ? '⏸' : '▶'}</button>
                    {props.router ? <RouterProvider router={props.router}/> : <div>Router not available</div>}
                </>
            )}
        </div>
    );
}

export default App;
